import React from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import HomePageXS from './HomePageXS'
import HomePageXL from './HomePageXL'

const news = (<>
  <div style={{ backgroundColor: '#fff', borderRadius: '0 30px 30px 0' }}>
    <div className="contentPadding" style={{ maxWidth: '1200px', margin: '2.5em 0' }}>
      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
        La Box Médicale est ouverte 7 jours sur 7 depuis janvier 2024
      </div>
      <div style={{ fontSize: '18px' }}>
        <p>Face aux difficultés croissantes pour trouver un médecin sur certains territoires, la Box Médicale a décidé d&apos;ouvrir le dimanche pour la rendre accessible 7 jours sur 7.</p>
        <p>La Box Médicale lutte contre le renoncement aux soins particulièrement dans les déserts médicaux. Nous nous engageons aux côtés des collectivités pour donner accès aux médecins généralistes et aux spécialistes au plus vite et au plus proche.</p>
      </div>
    </div>
  </div>
</>)

const cssMaterial = {
  fontSize: '25px',
  fontWeight: 'bold',
  borderWidth: '2px',
  borderColor: 'rgb(240, 240, 240)',
  borderStyle: 'solid',
  borderRadius: '25px',
  padding: '0.5em 60px',
  margin: '0 20px 20px 0'
}

const cssNumber = {
  color: '#ff4438',
  fontWeight: 'bold',
  display: 'inline-block',
  width: '1.5em'
}

const css = {
  cssMaterial,
  cssNumber
}

export default function HomePage () {
  const screens = useBreakpoint()

  return (
    <>
      {screens.xs && <HomePageXS news={news} css={css}/>}
      {!screens.xs && <HomePageXL news={news} css={css}/>}
    </>
  )
}
